module.exports = __webpack_public_path__ + "static/logo-dda726afad2dacbd8691cd0e26683622.svg";